/** header-mega.js: plays the mega-menu media column's video while its panel is open; delegated on document, so re-renders are safe. */
(function () {
  /** Mega-menu video: rendered with preload="none" and no autoplay, or it would download on every page while the panel is closed, so it only plays on open and pauses on close. */
  function toggleVideo(item, play) {
    const video = item && item.querySelector(".header__mega_media_video");
    if (!video) return;
    if (play) video.play().catch(() => {}); // lecture refusée (économie de données...) : sans effet
    else video.pause();
  }

  document.addEventListener("pointerover", (event) => {
    toggleVideo(event.target.closest(".header__item--has-mega"), true);
  });

  document.addEventListener("pointerout", (event) => {
    const item = event.target.closest(".header__item--has-mega");
    // Sortie réelle de l'élément, pas un déplacement interne.
    if (item && !item.contains(event.relatedTarget)) toggleVideo(item, false);
  });

  document.addEventListener("focusin", (event) => {
    toggleVideo(event.target.closest(".header__item--has-mega"), true);
  });

  document.addEventListener("focusout", (event) => {
    const item = event.target.closest(".header__item--has-mega");
    if (item && !item.contains(event.relatedTarget)) toggleVideo(item, false);
  });
})();
